import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { ContainerMaternalInfant } from './styles'
import { MaternalView, InfantView } from '~/components/maternalInfantMedicalView'
import { withDashboardLoader } from '~/components/shared'
import { INFANT_AGE } from '~/constants'
import { MaternalInfantHealthProceduresProvider, usePatient } from '~/context'
import { useDocumentTitle, useMaternalInfantViewSettings } from '~/hooks'
import { message } from '~/services'
import { getAgeByBirthDate } from '~/utils'

const MaternalInfantMedicalViewPage = (): JSX.Element => {
  useDocumentTitle(message('titles.timeline_maternal_infant'))
  const { patient, resetPatientTag } = usePatient()
  const isPatientAnInfant = (getAgeByBirthDate(patient?.birthDate) as number) <= INFANT_AGE

  const { cleanupMaternalInfantViewSettings, getMaternalInfantViewSettings } = useMaternalInfantViewSettings()
  const { medicalRecord: medicalRecordFromUrl } = useParams()
  const { medicalRecord: medicalRecordFromSettings } = getMaternalInfantViewSettings()

  const patientHasChanged = (): boolean => {
    return medicalRecordFromUrl !== medicalRecordFromSettings
  }

  useEffect(() => {
    if (patientHasChanged()) cleanupMaternalInfantViewSettings()
  }, [])

  useEffect(() => {
    resetPatientTag()
  }, [resetPatientTag])

  return (
    <MaternalInfantHealthProceduresProvider>
      <ContainerMaternalInfant>{isPatientAnInfant ? <InfantView /> : <MaternalView />}</ContainerMaternalInfant>
    </MaternalInfantHealthProceduresProvider>
  )
}

export const MaternalInfantMedicalView = withDashboardLoader(MaternalInfantMedicalViewPage)
